export function Phrase() {
  return (
    <section
      id="phrase"
      data-motion-id="afc16972-184a-f674-57da-da840944b13c"
      className="section_phrase"
    >
      <div className="padding-vertical padding-huge">
        <div className="container-full">
          <div className="content_phrase">
            <div className="phrase_image-wrapper">
              <div
                data-motion-id="8743ad6e-c302-46fc-a887-02b5404664fa"
                className="platforms_image is-top"
              >
                <div
                  data-motion-id="51b7b609-9149-0b40-0c74-357be67267fe"
                  className="image_shading"
                ></div>
                <div
                  data-motion-id="349cb8b3-8d97-e205-f06f-8f7b765f88fd"
                  className="image_shading is-green"
                ></div>
                <img
                  src="/assets/images/Frame-188.png"
                  loading="lazy"
                  alt="Optical sensors and camera housings"
                />
              </div>
              <div
                data-motion-id="0549ac50-c85c-23ad-b741-c1f32b27af13"
                className="platforms_image editorial-frame editorial-frame--sage"
              >
                <div
                  data-motion-id="8ad133b7-f9f4-7e0c-7878-82b79a84c14b"
                  className="image_shading"
                ></div>
                <div
                  data-motion-id="e15c27e6-c4cc-a8cf-b3c2-c42358ef9942"
                  className="image_shading is-green"
                ></div>
                <img
                  src="/assets/images/editorial/forest-floor-512.webp"
                  srcSet="/assets/images/editorial/forest-floor-256.webp 256w, /assets/images/editorial/forest-floor-512.webp 512w, /assets/images/editorial/forest-floor-768.webp 768w"
                  sizes="(max-width: 479px) calc((100vw - 32px) / 2), 200px"
                  width="1254"
                  height="1254"
                  loading="lazy"
                  decoding="async"
                  alt="Illustrative forest floor with roots and moss"
                  className="editorial-image"
                />
                <p className="editorial-image-caption">Illustrative imagery</p>
                <div className="icon-position_bottom-right">
                  <div className="icon-embed-medium text-color-primary25 w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 40 40"
                      fill="none"
                      preserveAspectRatio="xMidYMid meet"
                      aria-hidden="true"
                      role="img"
                    >
                      <path
                        d="M6.66667 20.0005L0 40.0005H13.3333L6.66667 20.0005Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M6.66667 0.000488281L0 20.0005H13.3333L6.66667 0.000488281Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20 20.0005L13.3333 40.0005H26.6667L20 20.0005Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20 0.000488281L13.3333 20.0005H26.6667L20 0.000488281Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M33.3333 20.0005L26.6667 40.0005H40L33.3333 20.0005Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M33.3333 0.000488281L26.6667 20.0005H40L33.3333 0.000488281Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="phrase_wrapper">
              <p data-word-reveal="true" className="heading-xsmall heading-inline section-prose">
                From sensing to human oversight, Arcnova studies how the parts of an autonomous
                system relate to one another.
              </p>
            </div>
            <div className="phrase_animation-wrapper">
              <div className="phrase_animation-holder">
                <div
                  data-motion-id="86731408-a2fd-b9ad-5f64-1c7cbeedf9c2"
                  className="phrase_animaiton-highlighter"
                >
                  <div
                    data-motion-id="0ec5cfbb-69c3-5a03-470d-ed13a2b26074"
                    className="image_shading"
                  ></div>
                </div>
                <img
                  src="/assets/images/BG-Mountains.svg"
                  loading="lazy"
                  alt=""
                  className="alps_animation-bg-grid"
                />
                <img
                  src="/assets/images/Gradient_1.svg"
                  loading="lazy"
                  alt=""
                  className="alps_animation-gradient"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
